import React from 'react'
import Discount from './discount'
import CurrentPlan from './plan-details/current-plan'

const CancelRightPanel = props => {
  return (
    <>
      <CurrentPlan title='Affected subscription' insideContainer={false} />
      <Discount />
    </>
  )
}

export default CancelRightPanel
